import http from '@/http'
import { Theme } from '@/interfaces/global'

export const getTheme = (themeUrl?:string):Promise<Theme> => {
  return http.get(themeUrl || '/styles/user').then(res => res.data).catch(err => console.log("Could not get styles"))
}
